module.exports = __webpack_public_path__ + "static/media/vi-data-roaming-other_6.f429f805.png";